<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <el-row class="login_box">
      <el-col :md="{ span: 20 }" class="login_content">
        <div class="hidden-sm-and-down" style="margin-right: 20px">
          <el-image :src="loginAndRegisterBgSrc"></el-image>
        </div>
        <div class="login_box_item">
          <el-tabs
            type="border-card"
            :stretch="true"
            class="login_box_tab"
            v-model="activeName"
            @tab-click="tabClick"
          >
            <el-tab-pane label="登录" name="signIn">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="0px"
                class="login_box_form"
                onsubmit="return false;"
                v-if="loginType === 'account'"
              >
                <el-form-item label="" prop="username">
                  <el-input
                    type="text"
                    v-model="ruleForm.username"
                    placeholder="请输入用户名"
                    prefix-icon="el-icon-user-solid"
                    autocomplete="on"
                    name="username"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input
                    type="text"
                    v-model="ruleForm.password"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    clearable
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <div class="forget-btn">
                    <el-link
                      :underline="false"
                      style="margin-left: 10px"
                      v-on:click="findBackPassword()"
                      >忘记密码</el-link
                    >
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="login-submit-btn"
                    v-on:click="submitForm('ruleForm')"
                  >
                    登录
                  </el-button>
                </el-form-item>
              </el-form>
              <wxlogin
                :theme="'black'"
                :appid="this.$config.wxAppId"
                :scope="this.$config.wxSnsapiLogin"
                :redirect_uri="this.$config.wxloginRedirectUri"
                v-if="loginType === 'wechat'"
                style="text-align: center"
              ></wxlogin>
              <el-divider>其它登录方式</el-divider>
              <div class="more_sign_box">
                <el-button
                  size="mini"
                  icon="iconfont icon-weixin"
                  @click="changeLoginType('wechat')"
                  v-if="loginType === 'account'"
                >
                  微信登录
                </el-button>
                <el-button
                  size="mini"
                  icon="el-icon-lock"
                  @click="changeLoginType('account')"
                  v-if="loginType === 'wechat'"
                >
                  账号登录
                </el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :label="registerType === 'findPassWord' ? '找回密码' : '注册'"
              name="register"
            >
              <el-form
                :model="registerRuleForm"
                :rules="registerRules"
                ref="registerRuleForm"
                label-width="0px"
                class="login_box_form"
              >
                <el-form-item label="" prop="PhoneNumber">
                  <el-input
                    type="text"
                    v-model="registerRuleForm.PhoneNumber"
                    placeholder="请输入手机号"
                    prefix-icon="el-icon-user-solid"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="PassWord">
                  <el-input
                    type="text"
                    v-model="registerRuleForm.PassWord"
                    placeholder="设置密码"
                    prefix-icon="el-icon-lock"
                    clearable
                    show-password
                  ></el-input>
                  <em>密码强度：</em>
                  <el-progress
                    :stroke-width="10"
                    :percentage="progressPercentage"
                    :color="progressCustomColor"
                    :format="passwordStrengthFormat"
                    style="width: 60%"
                  ></el-progress>
                </el-form-item>
                <el-form-item label="" prop="confirmPassword">
                  <el-input
                    type="text"
                    v-model="registerRuleForm.confirmPassword"
                    placeholder="确认密码"
                    prefix-icon="el-icon-key"
                    clearable
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="VerificationCode">
                  <el-input
                    type="text"
                    v-model="registerRuleForm.VerificationCode"
                    maxlength="4"
                    placeholder="验证码"
                    style="float: left; width: 50%"
                  ></el-input>
                  <el-image
                    style="
                      float: right;
                      width: 20%;
                      margin-right: 29%;
                      height: 30px;
                    "
                    :src="imageCode"
                    fit="fill"
                    @click="getImageCode()"
                  >
                    <div slot="error" class="image-slot">
                      <span>加载中…</span>
                    </div>
                  </el-image>
                </el-form-item>
                <el-form-item label="" prop="PhoneCode">
                  <el-input
                    type="text"
                    v-model="registerRuleForm.PhoneCode"
                    maxlength="4"
                    placeholder="短信验证码"
                    style="float: left; width: 50%"
                  ></el-input>
                  <el-button
                    style="float: right; width: 30%; margin-right: 19%"
                    v-on:click="sendPhoneCode()"
                  >
                    获取验证码
                  </el-button>
                  <span v-if="showPhoneCodeMessage">
                    短信验证码已发送，请您在5分钟内填完。
                  </span>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="login-submit-btn"
                    v-on:click="submitRegisterForm('registerRuleForm')"
                  >
                    {{ registerType === 'findPassWord' ? '修改' : '注册' }}
                  </el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <HomeFooter></HomeFooter>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin'
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    wxlogin,
    HomeHead,
    HomeFooter
  },
  data () {
    const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,13}$/
    var validateNewPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else {
        callback()
      }
    }
    const validateComfirmPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else if (this.registerRuleForm.PassWord !== value) {
        callback(new Error('确认密码与新密码不一致！'))
      } else {
        callback()
      }
    }
    const phoneReg = /^1[0-9]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      queryRedirect: '',
      fit: 'contain',
      loginAndRegisterBgSrc: require('../assets/images/LoginAndRegisterBg.png'),
      activeName: 'signIn',
      ruleForm: {
        username: '',
        password: '',
        isRemember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 13, message: '长度在 6 到 13 个字符', trigger: 'blur' }
        ]
      },
      registerRuleForm: {
        PhoneNumber: null,
        PassWord: null,
        PhoneCode: null,
        PhoneEncryptCode: null,
        PhoneEncryptExpireTime: null,
        VerificationCode: null,
        EncryptCode: null
      },
      registerRules: {
        PhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        PassWord: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validateNewPwd, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateComfirmPwd, trigger: 'blur' }
        ],
        VerificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        PhoneCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的短信验证码', trigger: 'blur' }
        ]
      },
      progressPercentage: 0,
      progressCustomColor: '#fff',
      imageCode: '',
      verificationPhoneCode: {
        EncryptCode: '',
        InputCode: '',
        PhoneNumber: ''
      },
      showPhoneCodeMessage: false,
      registerType: 'register',
      loginType: 'account'
    }
  },
  methods: {
    submitForm (formName) {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = new URLSearchParams()
          params.append('grant_type', 'password')
          params.append('login_mode', 'user')
          params.append('username', _this.ruleForm.username)
          params.append('password', _this.ruleForm.password)
          _this.$api.account.login(params)
            .then(data => {
              const saveParam = {
                token: data.access_token,
                token_type: data.token_type,
                refresh_token: data.refresh_token,
                expires_in: data.expires_in,
                issued: data['.issued'],
                expires: data['.expires'],
                role: 'user',
                rememberClient: _this.ruleForm.isRemember
              }
              _this.$store.commit('ADD_ACCOUNT', saveParam)
              const fellWarn = {
                isDisplayed: false
              }
              localStorage.setItem('FeeWarn', JSON.stringify(fellWarn))
              // _this.$router.push(_this.queryRedirect)
              _this.$router.push({ path: '/meetingList' })
              openLoading.close()
            }).catch(err => {
              openLoading.close()
              return err
            })
        } else {
          openLoading.close()
          return false
        }
      })
    },
    sendPhoneCode () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$refs.registerRuleForm.validateField('PhoneNumber', validError => {
        if (!validError) {
          _this.$refs.registerRuleForm.validateField('VerificationCode', validError => {
            if (!validError) {
              _this.verificationPhoneCode.InputCode = _this.registerRuleForm.VerificationCode
              _this.verificationPhoneCode.PhoneNumber = _this.registerRuleForm.PhoneNumber
              _this.$api.verificationCode.sendPhoneCode(_this.verificationPhoneCode).then(data => {
                // alert(data.Code)
                _this.registerRuleForm.PhoneEncryptCode = data.EncryptCode
                _this.registerRuleForm.PhoneEncryptExpireTime = data.EncryptExpireTime
                _this.registerRuleForm.EncryptPhoneNumber = data.EncryptPhoneNumber
                _this.showPhoneCodeMessage = true
                setTimeout(function () {
                  _this.showPhoneCodeMessage = false
                }, 60000)

                openLoading.close()
              }).catch(err => {
                openLoading.close()
                return err
              })
            } else {
              openLoading.close()
              return false
            }
          })
        } else {
          openLoading.close()
          return false
        }
      })
    },
    submitRegisterForm (formName) {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_this.registerType === 'register') {
            _this.registerRuleForm.EncryptCode = _this.verificationPhoneCode.EncryptCode
            _this.$api.account.register(_this.registerRuleForm).then(data => {
              _this.activeName = 'signIn'
              openLoading.close()
              _this.$message({
                type: 'success',
                message: '注册成功，请登录！'
              })
            }).catch(err => {
              openLoading.close()
              return err
            })
          }
          if (_this.registerType === 'findPassWord') {
            _this.registerRuleForm.EncryptCode = _this.verificationPhoneCode.EncryptCode
            _this.$api.account.resetPwd(_this.registerRuleForm).then(data => {
              _this.activeName = 'signIn'
              openLoading.close()
              _this.$message({
                type: 'success',
                message: '修改成功，请登录！'
              })
            }).catch(err => {
              openLoading.close()
              return err
            })
          }
        } else {
          openLoading.close()
          return false
        }
      })
    },
    // 忘记密码
    findBackPassword: function () {
      this.$router.push({ name: 'login', params: { loginType: 'findPassWord' } })
    },
    passwordStrengthFormat: function (percentage) {
      if (percentage <= 33) { return '弱' }
      if (percentage > 33 && percentage <= 66) { return '中' }
      if (percentage > 66 && percentage <= 100) { return '强' }
    },
    checkStrong (val) {
      let lv = 0
      if (val.match(/[a-z]/g)) { lv++ }
      if (val.match(/[0-9]/g)) { lv++ }
      if (val.match(/(.[^a-z0-9])/g)) { lv++ }
      if (val.length < 6) { lv = 0 }
      if (lv > 3) { lv = 3 }

      return lv
    },
    getImageCode: function () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$api.verificationCode.getImageCode().then(data => {
        _this.imageCode = 'data:image/png;base64,' + data.ImageCode
        _this.verificationPhoneCode.EncryptCode = data.EncryptCode
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    tabClick (tab, event) {
      this.$router.push({ name: 'login', params: { loginType: this.activeName } })
    },
    changeLoginType: function (type) {
      this.loginType = type
    },
    getwxAccessToken () {
      const _this = this
      // console.log(_this.$route.query.code)
      const openLoading = _this.openLoading()
      _this.$api.account.weChatAccessToken({ Code: _this.$route.query.code }).then(data => {
        if (data.isexist) {
          _this.wxLogin(data)
        } else {
          //   window.localStorage.setItem('wx_access_token', JSON.stringify(data))
          //   openLoading.close()
          //   _this.$router.push({ name: 'bind-mobile' })
          _this.wxLogin(data)
        }
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    wxLogin (accessTokenInfo) {
      const _this = this
      const openLoading = _this.openLoading()
      const params = new URLSearchParams()
      params.append('grant_type', 'password')
      params.append('login_mode', 'wechat_login')
      params.append('access_token', accessTokenInfo.access_token)
      params.append('openid', accessTokenInfo.openid)
      params.append('unionid', accessTokenInfo.unionid)
      _this.$api.account.login(params).then(data => {
        const saveParam = {
          token: data.access_token,
          token_type: data.token_type,
          refresh_token: data.refresh_token,
          expires_in: data.expires_in,
          issued: data['.issued'],
          expires: data['.expires'],
          role: 'user',
          rememberClient: this.ruleForm.isRemember
        }
        this.$store.commit('ADD_ACCOUNT', saveParam)
        const fellWarn = {
          isDisplayed: false
        }
        localStorage.setItem('FeeWarn', JSON.stringify(fellWarn))
        this.$router.push({ path: '/meetingList' })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    }
  },
  watch: {
    '$route' (to, from) {
      const _this = this
      if (this.$route.params.loginType === 'findPassWord') {
        _this.activeName = 'register'
      } else {
        _this.activeName = this.$route.params.loginType
      }
      _this.registerType = _this.$route.params.loginType
      if (_this.activeName === 'register' || _this.activeName === 'findPassWord') {
        _this.getImageCode()
      }
      if (_this.$route.query.code) {
        _this.getwxAccessToken()
      }
    },
    'registerRuleForm.PassWord': {
      handler (newValue, oldValue) {
        const lv = this.checkStrong(newValue)
        if (lv === 1) {
          this.progressPercentage = 33
          this.progressCustomColor = '#F56C6C'
        } else if (lv === 2) {
          this.progressPercentage = 66
          this.progressCustomColor = '#E6A23C'
        } else if (lv === 3) {
          this.progressPercentage = 100
          this.progressCustomColor = '#409EFF'
        } else {
          this.progressPercentage = 0
          this.progressCustomColor = '#eee'
        }
      }
    }
    // activeName: {
    //   handler (newValue, oldValue) {
    //     this.$route.params.loginType = this.activeName
    //     if (this.activeName === 'register') {
    //       // this.registerType = 'register'

    //       this.getImageCode()
    //     }
    //   }
    // }
  },
  created () {
    if (this.$route.query.code) {
      this.getwxAccessToken()
    } else {
      const _this = this
      if (_this.$route.params.loginType === 'findPassWord') {
        _this.activeName = 'register'
      } else {
        if (_this.$route.params.loginType) {
          _this.activeName = _this.$route.params.loginType
        }
      }
      _this.queryRedirect = _this.$route.query.redirect
      _this.registerType = _this.$route.params.loginType
      if (_this.activeName === 'register' || _this.activeName === 'findPassWord') {
        _this.getImageCode()
      }
      document.onkeydown = function (e) { // 按下回车提交
        const key = window.event.keyCode
        // 事件中keycode=13为回车事件
        if (key === 13) {
          _this.submitForm('ruleForm')
        }
      }
    }
  }
}
</script>

<style lang="less">
.login_box {
  background-color: #fff;
  margin: 0px;
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background: url('../assets/images/brand/sucess08.png') no-repeat center;
  background-size: contain;
}
.login_content {
  height: auto;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.login_box .login_box_item {
  flex-grow: 0;
  align-self: flex-start;
  width: 100%;
  min-width: 280px;
  max-width: 450px;
}
.login_box .login_box_tab {
  height: 100%;
}
.login_box .login_box_form {
  margin: 30px auto;
}
.forget-btn {
  float: right;
  display: block;
  padding: 0px 5px 0px 0px;
}
.login-submit-btn {
  width: 100%;
  border-radius: 6px;
  font-size: 16px;
  border: 0;
  letter-spacing: 18px;
}
.more_sign_box {
  padding: 15px 0px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
</style>
